import type { ReactNode } from 'react';

import { Tooltip } from '#/components/Tooltip/Tooltip';
import { useViewportBreakpointValue } from '#/hooks/viewport/useViewportBreakpointValue';
import { useI18n } from '#/i18n/hooks/useI18n';

type Props = {
  children: ReactNode;
};

export function ListingViewActionButtonsDisabledInPreview({ children }: Props) {
  const { i18n } = useI18n();

  const placement = useViewportBreakpointValue({
    xs: 'top-center' as const,
    md: 'bottom-center' as const,
  });

  return (
    <Tooltip
      content={i18n("You can't take these actions in Preview Mode")}
      triggerCondition
      variant="filled"
      placement={placement}
      size="large"
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'not-allowed',
        }}
      >
        <div style={{ pointerEvents: 'none' }}>{children}</div>
      </div>
    </Tooltip>
  );
}
